import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NewsModel} from '../../../models/NewsModel';

@Component({
  selector: 'app-popup-news-modal',
  templateUrl: './popup-news-modal.component.html'
})
export class PopupNewsModalComponent {
  checked = false;

  constructor(
    private dialog: MatDialogRef<PopupNewsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewsModel) { }

  goToVideo() {
    window.open(this.data.newsRecords[0].videoUrl, '_blank');
  }

  onCloseClick() {
    if (this.checked) {
      localStorage.setItem('popupNews', `${this.data.id}`);
    }
    this.dialog.close();
  }
}
